/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventinpasterror3Inputs */

const en_eventinpasterror3 = /** @type {(inputs: Eventinpasterror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot create events in the past.`)
};

const de_eventinpasterror3 = /** @type {(inputs: Eventinpasterror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events in der Vergangenheit kannst du nicht erstellen.`)
};

/**
* | output |
* | --- |
* | "Cannot create events in the past." |
*
* @param {Eventinpasterror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventinpasterror3 = /** @type {((inputs?: Eventinpasterror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventinpasterror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventinpasterror3(inputs)
	return de_eventinpasterror3(inputs)
});
export { eventinpasterror3 as "eventInPastError" }